module.exports = __webpack_public_path__ + "b5f80ab541ac8d5639044a63d43cfdb3.svg";